/**
 * SAYKI — Outlet Collections carousel
 * Wires prev/next buttons to scroll the product track horizontally.
 * Mobile scroll is handled natively (touch).
 */
(function () {
  'use strict';

  function initRow(row) {
    var track = row.querySelector('[data-outlet-track]');
    var prevBtn = row.querySelector('.sayki-outlet__nav--prev');
    var nextBtn = row.querySelector('.sayki-outlet__nav--next');

    if (!track) return;

    function getStep() {
      var firstItem = track.querySelector('.sayki-outlet__product');
      if (!firstItem) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
      return firstItem.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= max;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function init() {
    var rows = document.querySelectorAll('.sayki-outlet__row');
    for (var i = 0; i < rows.length; i++) {
      initRow(rows[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor re-renders the section
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var rows = e.target.querySelectorAll('.sayki-outlet__row');
    for (var i = 0; i < rows.length; i++) {
      initRow(rows[i]);
    }
  });
})();